import { render } from "./bread-crumbs.vue?vue&type=template&id=61c9d127"
import script from "./bread-crumbs.vue?vue&type=script&lang=js"
export * from "./bread-crumbs.vue?vue&type=script&lang=js"

import "./bread-crumbs.vue?vue&type=style&index=0&id=61c9d127&lang=postcss"
script.render = render

export default script